package org.hs_soft.runmynesto.domain.usecase.options.cash_register_config

import org.hs_soft.runmynesto.domain.model.home.options.cash_register_config.devices.create_new_region.CreateNewRegionModel
import org.hs_soft.runmynesto.domain.repository.network_datasource.options.cash_register_config.CreateNewRegionReopisotry


class CreateNewRegionUseCase(
    private val repository: CreateNewRegionReopisotry
) {
    suspend operator fun invoke(
       name:String,
       departmentId:String,
    ): CreateNewRegionModel {
        return repository.createNewRegion(
            name=name,
            departmentId =departmentId
        )
    }
}